// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"8125":"4dabd7e97ece42e8","8239":"cd038b4f662f38c1"}[chunkId] + ".css";
};